module.exports = {"2006-01-01T00:00:00Z":13.574855380588108,"2007-01-01T00:00:00Z":13.43506866031223,"2008-01-01T00:00:00Z":13.66217072804769,"2009-01-01T00:00:00Z":13.518477969699436,"2010-01-01T00:00:00Z":13.562892066107857,"2011-01-01T00:00:00Z":13.667610274420845,"2012-01-01T00:00:00Z":13.710831642150879,"2013-01-01T00:00:00Z":13.597016758388943,"2014-01-01T00:00:00Z":13.830776320563423,"2015-01-01T00:00:00Z":14.097412533230251,"2016-01-01T00:00:00Z":13.607405556572807,"2017-01-01T00:00:00Z":13.793942133585611}


//////////////////
// WEBPACK FOOTER
// ./src/components/core/predictivos/adaptecca_2.json
// module id = 1088
// module chunks = 1